import { DraggedSingleData } from "../../../../components/ui/DragToolsUI";
import { HudActions } from "../../../../components/ui/hud/HUDUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../misc/constants";
import { globals } from "../../../../misc/globals";
import { DaarcBaseScenario, DebriefScenarioLocation } from "../../../DaarcBaseScenario";
import GeneralNeutralStateMain, { GeneralNeutralStatePart8Config, GeneralNeutralStateMainConfig } from "../GeneralNeutralStateMain";
import GeneralNeutralStatePart1 from "./GeneralNeutralStatePart1";

var count = 0;
export default class GeneralNeutralStatePart8 extends BaseScenarioPart<DaarcBaseScenario> {
	private alreadyDone = false;
	private get config(): GeneralNeutralStatePart8Config {
		return this.scenarioConfig.part8Config;
	}
	constructor(private main: GeneralNeutralStateMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralNeutralStateMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		context._scenario.currentTaskMessage = 'Please Administer Medications';
		context._scenario.uiWrapper.displayHUD({
			score: context._scenario.totalScore,
			maxScore: this._scenario.maxScore,
			onActionClicked: (actionType: HudActions, personIconDown: string, title: string) => {
				if(context.main.onHudActionClicked(actionType, personIconDown, title)) {
					return true;
				}
				switch(actionType) {
					case HudActions.AdministerMedications:
						context.showUI(personIconDown, title);
						return true;
					default:
						context._scenario.displayMessage(context._scenario.currentTaskMessage);
						return false;
				}
			}
		}, context._scenario.hudId);

		context.scenario.sideMenuId = context.scenario.uiWrapper.displaySideMenu({
			updatedStuff: {

			}
		}, context.scenario.sideMenuId);

		if(!context.main.config.isTestScenario && !context.main.config.isEmanuelMcKenzie) {
			context.scenario.toolbagId = context._scenario.uiWrapper.displayToolbag({
				onShouldShowOverlay: () => {
					return false;
				},
				onToolClicked: (data: DraggedSingleData) => {
					context._scenario.displayMessage(context.scenarioConfig.isTestScenario ? context.main.toolsMessageTestScenario : context._scenario.currentTaskMessage);
				}
			}, context._scenario.toolbagId);
		}
	}

	public showUI(personIcon: string, title: string) {
		const context = this;
		if(count >= this.config.meds.length) {
			return;
		}
		var meds = this.config.meds[count];
		var txt = meds.title;
		this.scenario.uiWrapper.displayAdministerMedsUI({
			personIconImage: personIcon,
			drugText: txt,
			onCloseClicked: () => {
				this.scenario.uiWrapper.destroyAllUIInstances();
			},
			onAdministerClicked: () => {
				var audio = meds.audioPrefix;
				GeneralNeutralStatePart1.disableMenuItemCallback();

				context._scenario.uiWrapper.displayHUD({
					disabledActions: [HudActions.PreOxygenatePatient]
				}, context._scenario.hudId);

				var suffix = 'PH';
				switch(title) {
					case 'respiratoryTherapist':
						suffix = 'RT';
						break; 
					case 'nurse':
						suffix = 'RN';
						break;
				}

				audio += suffix;

				var onDoneWithPopup = context._scenario.doSomething('' + txt + '');
				setTimeout(() => {
					onDoneWithPopup();
					context.scenario.gameManager.SoundManager.playSound({
						src: './assets/audio/hud/' + audio +'.mp3',
						autoPlay: true,
						enableClosedCaptioning: false,
						muted: globals.isMuted,
						volume: 1
					});
					if(count === 0) {
						count++;
						if(context.config.onSingleMedAdministered) {
							context.config.onSingleMedAdministered(meds);
						}
						context._scenario.uiWrapper.displaySideMenu({
							updatedStuff: {
								isApneaTimerIdle: false,
								onInductionTimerRanOut2: () => {
									context.main.loopVideo(this, context.config.onApneaStartedVideoChapter());
								}
							}
						}, context._scenario.sideMenuId);
						if(!context.alreadyDone) {
							context._scenario.addScore(context._scenario.administermedsPoints);
							context.alreadyDone = true;
						}
						context.scenario.setDebriefScenarioLocation(DebriefScenarioLocation.AfterMeds);
						context.showUI(personIcon, title);
						context.onDone();
					} else {
						if(context.config.onPatientFullyMedicated) {
							context._scenario.addScore(context._scenario.administermedsPoints);
							context.config.onPatientFullyMedicated();
						}
						// context.scenario.debriefSetAdministeringText('You correctly medicated your patient and earned maximum points.');
					}
				}, constants.doSomethingTimeout);
			}
		})
	}
}